<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row flex-column-reverse flex-sm-row">
                        <div class="col-md-6">
                            <h2>
                                Edit User
                            </h2>
                        </div>
                        <div class="col-md-6 text-right">
                            <a v-if="$userIsAdmin() || $canManageCompany(loggedInUser.company_id)" :href="`/companies/${loggedInUser.company_id}`" class="link">To company user list</a>
                            <a v-if="$userIsAdmin()" href="/users" class="link">To user list</a>
                        </div>
                    </div>
                    <form @submit.stop.prevent="onSubmit" v-if="user">
                        <messages :messages="messages"/>
                        <div class="row">
                            <div class="col-md-9 container-search label-fixed user">
                                <div class="user-block">
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Company"
                                                      :label-for="getId('company_id')"
                                                      :state="fieldState('company_id')"
                                                      :invalid-feedback="invalidField('company_id')"
                                        >
                                            <b-form-select
                                                :id="getId('company_id')"
                                                v-model="user.company_id"
                                                :disabled="!$userIsSuperAdmin()"
                                                class="form-control"
                                            >
                                                <option :value="null">Select a company</option>
                                                <option :value="company.id" v-for="company in companies">{{ company.name }}</option>
                                            </b-form-select>

                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="User Name / Login"
                                                      :label-for="getId('qwerty')"
                                                      :state="fieldState('username')"
                                                      :invalid-feedback="invalidField('username')"
                                        >
                                            <b-form-input
                                                :id="getId('qwerty')"
                                                type="text"
                                                autocomplete="off"
                                                v-model="user.username"
                                                :state="fieldState('username')"
                                                placeholder="Enter username">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="First Name"
                                                      :label-for="getId('first_name')"
                                                      :state="fieldState('first_name')"
                                                      :invalid-feedback="invalidField('first_name')"
                                        >
                                            <b-form-input
                                                :id="getId('first_name')"
                                                type="text"
                                                v-model="user.first_name"
                                                :state="fieldState('first_name')"
                                                placeholder="Enter first name">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Last Name"
                                                      :label-for="getId('last_name')"
                                                      :state="fieldState('last_name')"
                                                      :invalid-feedback="invalidField('last_name')"
                                        >
                                            <b-form-input
                                                :id="getId('last_name')"
                                                type="text"
                                                v-model="user.last_name"
                                                :state="fieldState('last_name')"
                                                placeholder="Enter last name">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Email"
                                                      :label-for="getId('email')"
                                                      :state="fieldState('email')"
                                                      :invalid-feedback="invalidField('email')"
                                        >
                                            <b-form-input
                                                    :id="getId('email')"
                                                    type="text"
                                                    v-model="user.email"
                                                    :state="fieldState('email')"
                                                    placeholder="Enter email">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Secondary Email"
                                                      :label-for="getId('secondary_email')"
                                                      :state="fieldState('secondary_email')"
                                                      :invalid-feedback="invalidField('secondary_email')"
                                        >
                                            <b-form-input
                                                    :id="getId('secondary_email')"
                                                    type="text"
                                                    v-model="user.secondary_email"
                                                    :state="fieldState('secondary_email')"
                                                    placeholder="Enter Secondary Email">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Bid Email User"
                                                      title="Only bid notifications will be sent here"
                                                      :label-for="getId('bid_notification_user_id')"
                                                      :state="fieldState('bid_notification_user_id')"
                                                      :invalid-feedback="invalidField('bid_notification_user_id')"
                                        >
                                            <user-selector
                                                v-model="user.bid_notification_user_id"
                                                placeholder="-"
                                                :allow-empty="true"
                                                :names-first="true"
                                                :include-me="true"
                                                :include-dealers="false"
                                                :include-admins="true"
                                            >
                                            </user-selector>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group
                                                      class="col-md-6"
                                                      title="Used in Motorcentral"
                                                      label="Owner Key"
                                                      :label-for="getId('Motor Central Key')"
                                                      :state="fieldState('ownerkey')"
                                                      :invalid-feedback="invalidField('ownerkey')"
                                        >
                                            <b-form-input
                                                    :disabled="!$userIsSuperAdmin()"
                                                    :id="getId('ownerkey')"
                                                    type="text"
                                                    v-model="user.ownerkey"
                                                    :state="fieldState('ownerkey')"
                                                    readonly
                                                    placeholder="Ownerkey">
                                            </b-form-input>

                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Phone"
                                                      :label-for="getId('phone')"
                                                      :state="fieldState('phone')"
                                                      :invalid-feedback="invalidField('phone')"
                                        >
                                            <b-form-input
                                                    :id="getId('phone')"
                                                    type="text"
                                                    v-model="user.profile.phone"
                                                    :state="fieldState('phone')"
                                                    placeholder="Enter phone number">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>

                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Fax"
                                                      :label-for="getId('fax')"
                                                      :state="fieldState('fax')"
                                                      :invalid-feedback="invalidField('fax')"
                                        >
                                            <b-form-input
                                                :id="getId('fax')"
                                                type="text"
                                                v-model="user.profile.fax"
                                                :state="fieldState('fax')"
                                                placeholder="Enter fax">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Mobile"
                                                      :label-for="getId('mobile')"
                                                      :state="fieldState('mobile')"
                                                      :invalid-feedback="invalidField('mobile')"
                                        >
                                            <b-form-input
                                                :id="getId('mobile')"
                                                type="text"
                                                v-model="user.profile.mobile"
                                                :state="fieldState('mobile')"
                                                placeholder="Enter mobile">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>

                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Address"
                                                      :label-for="getId('address')"
                                                      :state="fieldState('address')"
                                                      :invalid-feedback="invalidField('address')"
                                        >
                                            <b-form-textarea
                                                :id="getId('address')"
                                                type="text"
                                                v-model="user.profile.address"
                                                :state="fieldState('address')"
                                                placeholder="Enter address">
                                            </b-form-textarea>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="City"
                                                      :label-for="getId('city')"
                                                      :state="fieldState('city')"
                                                      :invalid-feedback="invalidField('city')"
                                        >
                                            <b-form-input
                                                :id="getId('city')"
                                                type="text"
                                                v-model="user.profile.city"
                                                :state="fieldState('city')"
                                                placeholder="Enter city">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Post Code"
                                                      :label-for="getId('post_code')"
                                                      :state="fieldState('post_code')"
                                                      :invalid-feedback="invalidField('post_code')"
                                        >
                                            <b-form-input
                                                :id="getId('post_code')"
                                                type="text"
                                                v-model="user.profile.post_code"
                                                :state="fieldState('post_code')"
                                                placeholder="Enter post code">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Country"
                                                      :label-for="getId('country_id')"
                                                      :state="fieldState('country_id')"
                                                      :invalid-feedback="invalidField('country_id')"
                                        >
                                            <b-form-select
                                                v-if="$userIsAdmin()"
                                                :id="getId('country_id')"
                                                class="form-control"
                                                v-model="user.country_id"
                                            >
                                                <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                                            </b-form-select>
                                            <template v-else-if="user.country && user.country.name">{{user.country.name}}</template>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Sales rep"
                                                      :label-for="getId('sales_rep')"
                                                      :state="fieldState('sales_rep')"
                                                      :invalid-feedback="invalidField('sales_rep')"
                                        >
                                            <b-form-select
                                                v-if="$userIsAdmin()"
                                                :id="getId('sales_rep_id')"
                                                v-model="user.sales_rep_id"
                                                class="form-control"
                                            >
                                                <option :value="null">None</option>
                                                <option :value="user.id" v-for="user in reps">{{ user.name }}</option>
                                            </b-form-select>
                                            <template v-else-if="user.sales_rep && user.sales_rep.name">{{user.sales_rep.name}}</template>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Customer Region"
                                                      :label-for="getId('region_id')"
                                                      :state="fieldState('region_id')"
                                                      :invalid-feedback="invalidField('region_id')"
                                        >
                                            <b-form-select
                                                v-if="$userIsAdmin()"
                                                :id="getId('region_id')"
                                                v-model="user.region_id"
                                                class="form-control"
                                            >
                                                <option :value="region.id" v-for="region in regions">{{ region.name }}</option>
                                            </b-form-select>
                                            <template v-else-if="user.region && user.region.name">{{user.region.name}}</template>

                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group
                                                      class="col-md-6"
                                                      label="Status"
                                                      :label-for="getId('status_id')"
                                                      :state="fieldState('status_id')"
                                                      :invalid-feedback="invalidField('status_id')"
                                        >
                                            <b-form-select
                                                :disabled="!$userIsSuperAdmin()"
                                                :id="getId('status_id')"
                                                v-model="user.status_id"
                                                class="form-control"
                                            >
                                                <option :value="status.id" v-for="status in statuses">{{ status.name }}</option>
                                            </b-form-select>

                                        </b-form-group>
                                        <b-form-group v-if="$userIsAdmin()" class="col-md-6"
                                                      label="Auction Type"
                                                      :label-for="getId('auction_type')"
                                                      :state="fieldState('auction_type')"
                                                      :invalid-feedback="invalidField('auction_type')"
                                        >
                                            <b-form-select
                                                :id="getId('auction_type')"
                                                v-model="user.auction_type"
                                                class="form-control"
                                            >
                                                <option :value="1">Default</option>
                                                <option :value="2">Specify</option>
                                            </b-form-select>
                                            <template v-if="user.auction_type === 2 && $userIsSuperAdmin()">
                                                <a href="#!" @click.prevent="showAuctionSiteModal = true">Specify auctions</a>

                                                <b-modal id="auction-sites-modal"
                                                         v-model="showAuctionSiteModal"
                                                         title="Select auction sites">
                                                    <template #modal-footer="{ ok, cancel, hide }">
                                                        <b-button size="sm" variant="danger" @click="showAuctionSiteModal = false">
                                                            Close
                                                        </b-button>
                                                    </template>
                                                    <auction-sites :user="user"></auction-sites>
                                                </b-modal>
                                            </template>


                                        </b-form-group>
                                    </div>

                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Bid Color"
                                                      :label-for="getId('profile.bid_color')"
                                                      :state="fieldState('profile.bid_color')"
                                                      :invalid-feedback="invalidField('profile.bid_color')">
                                            <b-form-input
                                                :id="getId('bid_color')"
                                                type="color"
                                                v-model="user.profile.bid_color"
                                                :state="fieldState('profile.bid_color')"
                                                value="#fff"
                                                class="input-color"
                                                placeholder="">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group v-if="$userIsSuperAdmin() && user.role_id !== 2" class="col-md-6"
                                                      label="Nichibo User"
                                                      :label-for="getId('nichibo_user')"
                                                      :state="fieldState('nichibo_user')"
                                                      :invalid-feedback="invalidField('nichibo_user')">
                                            <b-form-select
                                                :id="getId('nichibo_user')"
                                                v-model="user.nichibo_user"
                                                class="form-control"
                                            >
                                                <option :value="null">None</option>
                                                <option value="SBL-CLIENT">SBL-CLIENT</option>
                                                <option value="SBL-SIMON">SBL-SIMON</option>
                                                <option value="SBL-GLENN">SBL-GLENN</option>
                                                <option value="SBL-JAMES">SBL-JAMES</option>
                                                <option value="SBL-MARC">SBL-MARC</option>
                                                <option value="SBL-HIROMI">SBL-HIROMI</option>
                                                <option value="SBL-MITCHELL">SBL-MITCHELL</option>
                                                <option value="SBL-VUKAN">SBL-VUKAN</option>
                                                <option value="SBL-JASON">SBL-JASON</option>
                                                <option value="SBL-SHANE">SBL-SHANE</option>
                                                <option value="SBL-TEST">SBL-TEST</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Global (on behalf)"
                                                      :label-for="getId('profile.global_list_colour')"
                                                      :state="fieldState('profile.global_list_colour')"
                                                      :invalid-feedback="invalidField('profile.global_list_colour')">
                                            <b-form-input
                                                :id="getId('global_list_colour')"
                                                type="color"
                                                v-model="user.profile.global_list_colour"
                                                :state="fieldState('profile.global_list_colour')"
                                                class="input-color"
                                                placeholder="">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Bid Initials"
                                                      :label-for="getId('bid_initials')"
                                                      :state="fieldState('bid_initials')"
                                                      :invalid-feedback="invalidField('bid_initials')">
                                            <b-form-input
                                                :disabled="!$userIsSuperAdmin()"
                                                :id="getId('bid_initials')"
                                                type="text"
                                                v-model="user.bid_initials"
                                                :state="fieldState('bid_initials')"
                                                placeholder="Bid Initials sent with the bid">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group v-if="$userIsAdmin() && user.role_id !== 2" class="col-md-6"
                                                      label="Nichibo Dealers User"
                                                      title="The nichibo user that this reps dealers will use"
                                                      :label-for="getId('nichibo_dealers_user')"
                                                      :state="fieldState('nichibo_dealers_user')"
                                                      :invalid-feedback="invalidField('nichibo_dealers_user')">
                                            <b-form-select
                                                :id="getId('nichibo_dealers_user')"
                                                v-model="user.nichibo_dealers_user"
                                                class="form-control"
                                            >
                                                <option :value="null">None</option>
                                                <option value="SBL-CLIENT">SBL-CLIENT</option>
                                                <option value="SBL-SIMON">SBL-SIMON</option>
                                                <option value="SBL-GLENN">SBL-GLENN</option>
                                                <option value="SBL-JAMES">SBL-JAMES</option>
                                                <option value="SBL-MARC">SBL-MARC</option>
                                                <option value="SBL-HIROMI">SBL-HIROMI</option>
                                                <option value="SBL-MITCHELL">SBL-MITCHELL</option>
                                                <option value="SBL-VUKAN">SBL-VUKAN</option>
                                                <option value="SBL-JASON">SBL-JASON</option>
                                                <option value="SBL-SHANE">SBL-SHANE</option>
                                                <option value="SBL-TEST">SBL-TEST</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">

                                        <b-form-group v-if="user.role_id !== 2" class="col-md-6"
                                                      label="Unsold Days"
                                                      :label-for="getId('unsold_days')"
                                                      :state="fieldState('unsold_days')"
                                                      :invalid-feedback="invalidField('unsold_days')">
                                            <b-form-input
                                                :disabled="!$userIsSuperAdmin()"
                                                :id="getId('unsold_days')"
                                                type="number"
                                                v-model="user.unsold_days"
                                                :state="fieldState('unsold_days')"
                                                placeholder="The number of days for  cars to move from unsold to public">
                                            </b-form-input>
                                        </b-form-group>

                                    </div>
                                    <div class="form-row">
                                        <b-form-group
                                                      class="col-md-6"
                                                      label="User Role"
                                                      :label-for="getId('role_id')"
                                                      :state="fieldState('role_id')"
                                                      :invalid-feedback="invalidField('role_id')"
                                        >
                                            <b-form-select
                                                :disabled="!$userIsSuperAdmin()"
                                                :id="getId('role_id')"
                                                v-model="user.role_id"
                                                class="form-control"
                                            >
                                                <option :value="role.id" v-for="role in user_roles">{{ role.name }}</option>
                                            </b-form-select>

                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="SBL User id (required for bidding)"
                                                      :label-for="getId('sbl_id')"
                                                      :state="fieldState('sbl_id')"
                                                      :invalid-feedback="invalidField('sbl_id')"
                                        >
                                            <b-form-input
                                                :disabled="!$userIsSuperAdmin()"
                                                :id="getId('sbl_id')"
                                                type="number"
                                                v-model="user.sbl_id"
                                                :state="fieldState('sbl_id')"
                                                placeholder="user ID from old system (in the url on the edit page)">
                                            </b-form-input>

                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Password"
                                                      :label-for="getId('password')"
                                                      :state="fieldState('password')"
                                                      :invalid-feedback="invalidField('password')"
                                        >
                                            <b-form-input
                                                :id="getId('password')"
                                                type="password"
                                                autocomplete="new-password"
                                                :readonly="ro_fields['password']"
                                                @focus="setReadOnly('password', false)"
                                                @blur="setReadOnly('password', true)"
                                                v-model="user.password"
                                                :state="fieldState('password')"
                                                placeholder="Enter password">
                                            </b-form-input>

                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Confirm password"
                                                      :label-for="getId('confirm_password')"
                                                      :state="fieldState('confirm_password')"
                                                      :invalid-feedback="invalidField('confirm_password')"
                                        >
                                            <b-form-input
                                                :id="getId('confirm_password')"
                                                type="password"
                                                :readonly="ro_fields['password_confirmation']"
                                                @focus="setReadOnly('password_confirmation', false)"
                                                @blur="setReadOnly('password_confirmation', true)"
                                                v-model="user.confirm_password"
                                                :state="fieldState('confirm_password')"
                                                placeholder="Enter confirm password">
                                            </b-form-input>

                                        </b-form-group>
                                    </div>
                                    <div class="form-row" v-if="$userIsAdmin()">
                                        <b-form-group class="col-md-12"
                                                      label="Note"
                                                      :label-for="getId('profile.note')"
                                                      :state="fieldState('profile.note')"
                                                      :invalid-feedback="invalidField('profile.note')">
                                            <b-form-textarea
                                                :rows="6"
                                                :id="getId('profile.note')"
                                                v-model="user.profile.note"
                                            >
                                            </b-form-textarea>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="col-md-6"
                                                    label="Shared Sales Rep"
                                                    :label-for="getId('shared_sales_rep')"
                                                    :state="fieldState('shared_sales_rep')"
                                                    :invalid-feedback="invalidField('shared_sales_rep')"
                                    >
                                        <template v-if="$userIsSuperAdmin()">
                                            <el-select 
                                                v-model="user.shared_sales_rep" 
                                                multiple 
                                                placeholder="-"         
                                                class="shared-sales-rep-select"
                                                :filter-by-shared-sales-reps="true"
                                                @change="handleSharedSalesRepChange"
                                            >
                                                <el-option
                                                    v-for="rep in sharedSalesReps"
                                                    :key="rep.id"
                                                    :label="rep.name"
                                                    :value="rep.id">
                                                </el-option>
                                            </el-select>
                                        </template>
                                        <template v-else>
                                            <div class="shared-sales-rep-display">
                                                <template v-if="user.shared_sales_rep && user.shared_sales_rep.length">
                                                    {{ user.shared_sales_rep.map(repId => getRepName(repId)).join(', ') }}
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                        </template>
                                    </b-form-group>
                                    <b-form-group class="col-md-6">
                                        <h3>leave blank to see sales rep stock</h3>
                                    </b-form-group>
                                </div>
                                <template v-if="$userIsSuperAdmin()">
                                    <inspection-emails v-if="$userIsSuperAdmin()" v-model="user.inspection_emails"
                                                       @inspection-email-deleted="addDeletedInspectionEmailId"></inspection-emails>
                                    <div class="form-row user-block">
                                        <b-form-group aria-describedby="pricing_rule_validate_feedback"
                                                      :state="fieldState('pricing_rule')">
                                            <h3 v-if="user.region">Please note the fees are in {{user.region.currency_code}}</h3>
                                            <fees v-model="user.pricing_rule" :user="user"></fees>
                                            <b-form-invalid-feedback slot="invalid-feedback" id="pricing_rule_validate_feedback">
                                                <span v-html="invalidField('pricing_rule')"></span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </template>
                                <template v-if="$userIsAdmin()">
                                    <div class="form-row user-block">
                                        <b-form-group aria-describedby="bump_bid_validate_feedback"
                                                      :state="fieldState('pricing_rule')">
                                            <bumpBids v-model="user.bump_bid"></bumpBids>
                                            <b-form-invalid-feedback slot="invalid-feedback" id="bump_bid_validate_feedback">
                                                <span v-html="invalidField('bump_bid')"></span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </template>


                                <div class="form-row user-block">
                                    <b-form-group class="col-md-6"
                                                  v-if="$userIsAdmin()"
                                                  label="Inactive date"
                                                  :label-for="getId('date_block')"
                                                  :state="fieldState('date_block')"
                                                  :invalid-feedback="invalidField('date_block')"
                                    >
                                        <b-form-input
                                            :id="getId('date_block')"
                                            type="date"
                                            v-model="blockDate"
                                            :state="fieldState('date_block')"
                                            placeholder="Enter inactive date">
                                        </b-form-input>

                                    </b-form-group>
                                    <b-form-group class="col-md-6"
                                                  v-if="$userIsAdmin()"
                                                  label="Preview_date"
                                                  :label-for="getId('date_preview')"
                                                  :state="fieldState('date_preview')"
                                                  :invalid-feedback="invalidField('date_preview')"
                                    >
                                        <b-form-input
                                            :id="getId('date_preview')"
                                            type="date"
                                            v-model="previewDate"
                                            :state="fieldState('date_preview')"
                                            placeholder="Enter preview date">
                                        </b-form-input>

                                    </b-form-group>
                                </div>
                                <div class="form-row user-block" v-if="$userIsAdmin()">
                                    <b-form-group
                                        class="col-md-12 vue-checkbox"
                                        key="enable_signature"
                                        :label-for="getId('enable_signature')"
                                        :state="fieldState('privileges.enable_signature')"
                                        :invalid-feedback="invalidField('privileges.enable_signature')">
                                        <b-form-checkbox
                                            :value="1"
                                            :id="getId('enable_signature')"
                                            v-model="user.privileges.enable_signature"
                                            :state="fieldState('privileges.enable_signature')">
                                            Enable Email Signature
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <div class="col-md-12" v-if="user.privileges.enable_signature">

                                        <a class="btn-link" @click.prevent="resetDefaultSignature" href="#!">
                                            Reset to default
                                        </a>
                                        <editor :api-key="TINYMCE_API_KEY" :init="editor_settings" v-model="user.signature"/>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <b-btn type="submit" class="btn">Save</b-btn>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="user-block">
                                    <div class="form-row" v-for="(priv_data,priv_name) in privileges">
                                        <div class="col-md-12"><h4>{{priv_name}}</h4></div>
                                        <div class="user-full-access col-md-12" v-if="$userIsSuperAdmin()">
                                            <template v-if="priv_name === 'Bidding'">
                                                <b-form-checkbox
                                                    v-model="biddingFullAccess" @change="setPrivileges(priv_name)"
                                                    :value="true" :unchecked-value="false"
                                                >
                                                    Full access
                                                </b-form-checkbox>
                                            </template>
                                            <template v-if="priv_name === 'Vehicle Info'">
                                                <b-form-checkbox
                                                    v-model="vehicleFullAccess" @change="setPrivileges(priv_name)"
                                                    :value="true" :unchecked-value="false"
                                                >
                                                    Full access
                                                </b-form-checkbox>
                                            </template>
                                        </div>
                                        <template v-for="(label, key) in priv_data" >
                                            <b-form-group
                                                v-if="$userIsSuperAdmin()"
                                                class="col-md-12 vue-checkbox"
                                                :label="label"
                                                :key="key"
                                                :label-for="getId(key)"
                                                :state="fieldState('privileges.' + key)"
                                                :invalid-feedback="invalidField('privileges.' + key)">
                                                <b-form-checkbox
                                                    :value="1"
                                                    :id="getId(key)"
                                                    v-model="user.privileges[key]"
                                                    :state="fieldState('privileges' + key)">
                                                </b-form-checkbox>
                                            </b-form-group>
                                            <div v-else class="privilege col-md-12">{{label}} -
                                                <span v-if="user.privileges[key]" class="text-success">Yes</span>
                                                <span v-else class="text-danger">No</span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Editor from '@tinymce/tinymce-vue'
import { mapState, mapActions } from 'vuex'
import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors, makeID} from '../../util/common'
import fees from './Fees';
import bumpBids from './BumpBids';
import InspectionEmail from './InspectionEmails'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import AuctionSites from '../Forms/AuctionSites'
import axios from "axios";
import InspectionEmails from "./InspectionEmails";
import UserSelector from '../Common/UserSelector';
export default {
    props: [
        'user_id',
    ],
    components: {fees, bumpBids,'user-selector': UserSelector, 'inspection-emails': InspectionEmails, 'auction-sites': AuctionSites, Editor},
    created(){
        this.getUser();
        this.$store.dispatch('countries/getCountries');
        this.getReps()
        this.getCompanies()
        this.$store.dispatch('region/getRegions');
        this.$store.dispatch('userStatuses/getUserStatuses');
        this.$store.dispatch('attendedAuctions/getAttentedAuctions');
        this.$store.dispatch('userRoles/getUserRoles');
    },
    mixins: [BootstrapValidation],
    data() {
        return {
            user: null,
            companies: [],
            showAuctionSiteModal: false,
            reps: [],
            ro_fields: {
                password: true,
                password_confirmation: true,
            },
            editor_settings: {
                height: 300,
                menubar: false,
                relative_urls : false,
                remove_script_host : false,
                convert_urls : true,
                placeholder: "Enter your email signature",
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount code'
                ],
                toolbar_location: 'bottom',
                toolbar: ['code | undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help']
            },
            userDefault: {
                company_id: null,
                first_name: null,
                last_name: null,
                bid_initials: null,
                email: null,
                secondary_email: null,
                bid_notification_user_id: null,
                signature: null,
                username: null,
                password: null,
                ownerkey: null,
                confirm_password: null,
                status_id: null,
                nichibo_user: 'SBL-SIMON',
                nichibo_dealers_user: 'SBL-SIMON',
                country_id: null,
                role_id: null,
                date_preview: null,
                date_block: null,
                sales_rep_id: null,
                sbl_id: null,
                region_id: null,
                auction_type: 1,
                attended_auction_id: null,
                profile:{
                    phone: null,
                    fax: null,
                    mobile: null,
                    address: null,
                    global_list_colour: null,
                    city: null,
                    post_code: null,
                    bid_color: null,
                    note: null,
                },
                privileges:{
                    enable_auto_notice: 0,
                    enable_market_price: 0,
                    display_auction_result: 0,
                    enable_email: 0,
                    enable_signature: 0,
                    enable_stock_emails: 0,
                    show_auction_site: 0,
                    show_lot_number: 0,
                    show_inspection: 0,
                    unlimited_login: 0,
                    can_edit_company: 0,
                    can_reset_password: 0,
                    can_block_stock_offers: 0,
                    can_block_mailout: 0,
                    can_view_public_stock: 0,
                    can_bid: 0,
                    can_bid_after_1pm: 0,
                    can_see_company_bids: 0,
                    can_see_company_stock: 0,
                    can_see_rep_bids: 0,
                    can_see_stock_eta: 0,
                    can_see_stock_price: 0,
                    is_company_manager: 0,
                },
                inspection_emails: [],
                shared_sales_rep: []
            },
            privileges: {
                'General Info': {
                    unlimited_login: 'Dual login',
                    enable_email: 'Enable Email (preview status will disable)',
                    enable_stock_emails: 'Enable stock email (enable email must be ticked)',
                    enable_unsold_stock_emails: 'Enable unsold stock email (enable email must be ticked)',
                    can_login_as: 'Can login as other people',
                    can_block_mailout: 'Can block mailout',
                    can_view_public_stock: 'Can view public stock',
                    can_block_stock_offers: 'Can block stock offers',
                    can_edit_company: 'Can edit company',
                },
                'Bidding': {
                    can_bid: 'Can bid',
                    can_bid_after_1pm: 'Can bid after 1pm',
                    can_see_company_bids: 'Can see company bids',
                    can_see_rep_bids: 'Can see other rep bids (for reps only)',
                    enable_auto_notice: 'Enable Auto Notice   (preview status will disable)',
                    enable_market_price: 'Enable Market Price Research',
                    display_auction_result: 'Auction Results   (preview status will disable)',
                    show_auction_site: 'Show Auction Site',
                    show_lot_number: 'Show Lot Number',
                    show_inspection: 'Show Inspection',
                    add_url_logo_image: 'Add Url/logo to images',
                },
                'Vehicle Info': {
                    can_see_company_stock: 'Can see company stock',
                    can_see_stock_price: 'Can see stock price',
                    can_see_stock_eta: 'Can see stock eta',
                    is_company_manager: 'Is company manager',
                },
                'Account': {
                    stop_credit: 'Stop Credit'
                }
            },
            messages: [],
            userDetail : this.user_detail,
            biddingFullAccess: false,
            vehicleFullAccess: false,

        }
    },
    computed: {
        ...mapState({
            countries: state => state.countries.all,
            users: state => state.users.all,

            regions: state => state.region.all,
            statuses: state => state.userStatuses.all,
            user_roles: state => state.userRoles.all,
        }),
        previewDate: {
            // getter
            get: function () {
                if(this.user.date_preview){
                    return window.moment(this.user.date_preview, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                }

                return null;
            },
            // setter
            set: function (newValue) {
                this.user.date_preview = window.moment(newValue, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss');
            }
        },

        blockDate: {
            // getter
            get: function () {
                if(this.user.date_block){
                    return window.moment(this.user.date_block, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                }

                return null;
            },
            // setter
            set: function (newValue) {
                this.user.date_block = window.moment(newValue, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss');
            }
        },
        sharedSalesReps: {
            // same as reps except remove the current user from the list and add all reps option
            get: function () {
                const allReps = this.reps.filter(rep => rep.id !== this.user.id)
                return [{id: 'all', name: 'All'}, ...allReps]
            }
        }
    },
    mounted() {
    },
    methods: {
        resetDefaultSignature() {
            const logo = window.location.origin + '/images/sbl-logo-blue.png';
            const sig = `
<table style="width: 100%; font-family: 'Arial';" border="0" width="100%" cellspacing="0" cellpadding="0">
   <tbody>
      <tr>
         <td style="width: 100%;">
            <p style="font-size: 15px; ">
                <strong>${this.user.first_name} ${this.user.last_name}</strong>
                <br /><strong>Job Title</strong><br />
            </p>
            <p style="font-size: 15px; ">
                P: ${this.user.profile.phone}<br />
                M: ${this.user.profile.mobile}<br />
                E: <a style="color: #006698;" href="mailto:${this.user.email}">${this.user.email}</a></p>
            <p><a style="text-decoration: none; color: #006698" href="https://www.car-go.co.nz/" target="_blank" rel="noopener"><strong style="color: #006698">www.car-go.co.nz</strong></a></p>
         </td>
      </tr>
      <tr>
         <td style="width: 100%;"><img src="${logo}" /></td>
      </tr>
      <tr>
         <td style="width: 100%;">
            <p style="font-size: 11px; line-height: 20px; "><strong>Confidentiality Notice: </strong>This email and any attachments are intended solely for the recipient (s) and may contain confidential or privileged information. If you are not the intended recipient, please delete this email immediately and notify the sender. Any unauthorized use, disclosure, or distribution is prohibited.
</p>
         </td>
      </tr>
   </tbody>
</table>
    `;
            this.user.signature = sig
        },
        async getCompanies(){
            const res = await axios.get(this.$laravelRoute('companies.list'))
            if (res && res.data && res.data.companies) {
                this.companies = res.data.companies
            }
        },
        setPrivileges(name){
            this.$nextTick(() => {
                let setKeys = Object.keys(this.privileges[name])
                let setValue = null
                if (name === 'Bidding') {
                    setValue = this.biddingFullAccess
                } else if (name === 'Vehicle Info') {
                    setValue = this.vehicleFullAccess
                }
                console.log(name, setValue)
                if (setValue !== null) {
                    setKeys.forEach(key => {
                        this.user.privileges[key] = setValue ? 1 : 0
                    })
                }
            })
        },
        async getReps(){
            let reps = await this.$store.dispatch('users/getSalesReps');
            reps.sort((a,b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();

                let comparison = 0;
                if (nameA > nameB) {
                    comparison = 1;
                } else if (nameA < nameB) {
                    comparison = -1;
                }
                return comparison;
            })
            this.reps = reps
        },
        objLookup(obj, key){
            return objLookup(obj, key);
        },
        getId(name){
            return name;
        },
        async onSubmit(){
            this.messages = [];
            this.errors = [];
            try {
                let response = await this.$store.dispatch('users/updateUser', this.user);
                if(response){
                    this.messages.push({type: 'success', message: response.message});
                    this.errors = [];
                    await this.getUser();
                }
            } catch (error) {
                console.warn('onSubmit error: ', error);
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        setReadOnly(field, on_off){
            this.ro_fields[field] = on_off
        },
        addDeletedInspectionEmailId(value) {
            this.user.inspection_emails_delete.push(value)
        },
        async getUser(){
            if (this.user_id) {
                this.user = await this.$store.dispatch('users/getEditUser', {user_id: this.user_id})
            } else {
                this.user = this.userDefault;
            }

            let biddingFullAccess = true
            Object.keys(this.privileges['Bidding']).forEach(key => {
                if (!this.user.privileges[key]) {
                    biddingFullAccess = false
                }
            })
            this.biddingFullAccess = biddingFullAccess
            let vehicleFullAccess = true
            Object.keys(this.privileges['Vehicle Info']).forEach(key => {
                if (!this.user.privileges[key]) {
                    vehicleFullAccess = false
                }
            })
            this.biddingFullAccess = vehicleFullAccess
            this.user.inspection_emails_delete = [];
        },
        getRepName(repId) {
            const rep = this.reps.find(r => r.id === repId);
            return rep ? `${rep.first_name} ${rep.last_name}` : '';
        },
        handleSharedSalesRepChange(value) {
            // if value(array) is contains all, select all options
            if (value.includes('all')) {
                this.user.shared_sales_rep = this.reps.filter(rep => rep.id !== this.user.id).map(rep => rep.id)
            } else {
                this.user.shared_sales_rep = value
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/User/EditUser.vue